exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".geofence-settings-key[data-v-560d4cf7] {\n  margin-top: 20px;\n  margin-right: 10px;\n  width: 20%;\n  display: inline-block;\n}\n.geofence-settings-key input[data-v-560d4cf7] {\n    width: 100%;\n}\n.geofence-settings-key-btn[data-v-560d4cf7] {\n  display: inline-block;\n  margin-right: 5px;\n  width: 8% !important;\n}\n.geofence-setting[data-v-560d4cf7] {\n  width: 20%;\n  margin-top: 35px;\n}\n.beta-geofence-banner[data-v-560d4cf7] {\n  margin-top: 15px;\n}\n.add-geofence-event[data-v-560d4cf7] {\n  top: -14px;\n}\n.card-icon[data-v-560d4cf7] {\n  background: #ff5245 !important;\n}\n", ""]);

// exports
